import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchMemberList, putMemberItem, postCompanyRegNo, postMemberEmailCheck, postMemberDetail, postMembersList, patchMemberApproval, deleteMember } from ".";
import { isDebug } from "../../utils";


export const useMemberListQuery = (queryOptions) => {
  return useQuery({
    queryKey: ["member-of-list", queryOptions],
    queryFn: () => fetchMemberList(queryOptions),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Member List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useMemberItemPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putMemberItem,
    onSuccess: () => {
      if (isDebug()) console.log("#@#@ Member Article put successfully!", new Date().toISOString());
      queryClient.invalidateQueries(["put-member-item"]);
    },
    onError: (error) => {
      console.error("#@#@ Failed to put Member Article :", new Date().toISOString(), error);
    },
  });
};

export const useCheckCompanyRegNoPost = (regno) => {
  return useQuery({
    queryKey: ["check-company-regno", {"RegNo": regno}],
    queryFn: () => postCompanyRegNo({"RegNo": regno}),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error Check Company Regno API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useCheckMemberEmailPost = (email) => {
    return useQuery({
    queryKey: ["check-member-email", {"Email": email}],
    queryFn: () => postMemberEmailCheck({"Email": email}),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error Check Company Regno API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useMemberDetailPost = (memberId) => {
    return useQuery({
    queryKey: ["post-member-detail", {"MemberId": memberId}],
    queryFn: () => postMemberDetail({"MemberId": memberId}),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error Check Company Regno API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
    enabled: (memberId !== null && memberId !== "" ),
  });
};

export const useMemberList4NamePost = (memberName, approvalYn) => {
    return useQuery({
    queryKey: ["member-of-list", {"MemberName": memberName, "ApprovalYn": approvalYn}],
    queryFn: () => postMembersList({"MemberName": memberName, "ApprovalYn": approvalYn}),
    select: (response) => {
      return response.data || {};
    },
    onError: (error) => {
      console.error("Error fetching Member List API contracts:", new Date().toISOString(), error);
    },
    staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
    refetchOnWindowFocus: false,
  });
};

export const useMemberApprovalPatchMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: patchMemberApproval,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Set Member Approval posted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["post-member-List"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to post Set Member Approval :", new Date().toISOString(), error);
        },
    });
};

export const useMemberDeleteMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteMember,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Delete Member posted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["post-member-List"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to post Delete Member :", new Date().toISOString(), error);
        },
    });
};